import apiClient from '../middleware/apiClient';
import { CONVOY_INDICATORS, SSM_CONTEXT_HUB, COTTON_SSM_CONTEXT_HUB } from '../helpers/apis';
import { COTTON_CONVOY_INDICATORS } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';
import { NO_XFINITY_SERVICES, NO_NOW_SERVICES, NO_MOBILE_SERVICES } from '../helpers/routes';
import { hasEverHadXfinityServices, hasEverHadNowServices, hasActiveMobileServices } from '../helpers/contextHub';
import { isNowPage } from '../helpers/now';
import isMobilePage from '../helpers/mobile';
import { flagEnabled } from '../helpers/featureFlags';

export const GET_CONTEXT_HUB = 'GET_CONTEXT_HUB';
export const GET_CONTEXT_HUB_SUCCESS = 'GET_CONTEXT_HUB_SUCCESS';
export const GET_CONTEXT_HUB_FAILURE = 'GET_CONTEXT_HUB_FAILURE';
export const GET_CONVOY_INDICATORS = 'GET_CONVOY_INDICATORS';
export const GET_CONVOY_INDICATORS_SUCCESS = 'GET_CONVOY_INDICATORS_SUCCESS';

// Valid event types for the Context Hub API
export const CONTEXT_HUB_EVENTS = {
  ACCOUNT: 'account',
  ACCOUNT_BASIC_INFO: 'account.basicInfo',
  ACCOUNT_XAP: 'account.xap',
  ACCOUNT_USER: 'account.user',
  INDICATOR_INFO_LITE: 'call.getContext.Indicator.info.lite',
};

function dispatchGetContextHub(events, isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_SSM_CONTEXT_HUB(events) : SSM_CONTEXT_HUB(events);
  return {
    type: GET_CONTEXT_HUB,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetConvoyIndicators(accNum, isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_CONVOY_INDICATORS : CONVOY_INDICATORS;
  return {
    type: GET_CONVOY_INDICATORS,
    payload: apiClient.fetch(endpoint(accNum)),
  };
}

function dispatchGetContextHubSuccess({ accountContext, indicatorContext }) {
  return {
    type: GET_CONTEXT_HUB_SUCCESS,
    payload: { accountContext, indicatorContext },
  };
}

function dispatchGetContextHubError(error) {
  return {
    type: GET_CONTEXT_HUB_FAILURE,
    payload: error,
  };
}

function dispatchGetConvoyIndicatorsSuccess(indicators) {
  return {
    type: GET_CONVOY_INDICATORS_SUCCESS,
    payload: indicators,
  };
}

export const getContextHub = (
  events = CONTEXT_HUB_EVENTS.ACCOUNT_BASIC_INFO,
) => async (dispatch, getState) => {
  const {
    contextHub: { cached } = {},
    auth: { xmAccount } = {},
  } = getState();

  if (cached) {
    return null;
  }

  if (isMobilePage(window.location.pathname)) {
    if (!xmAccount) {
      return null;
    }

    if (!hasActiveMobileServices(xmAccount)) {
      window.location.pathname = NO_MOBILE_SERVICES;
      return null;
    }
  }

  try {
    const isCottonSession = getCottonSession();
    const response = await dispatch(dispatchGetContextHub(events, isCottonSession)).payload;
    if (events.includes(CONTEXT_HUB_EVENTS.ACCOUNT_BASIC_INFO)) {
      const { services } = response.accountContext || {};

      if (!isNowPage(window.location.pathname) && !hasEverHadXfinityServices(services)) {
        window.location.pathname = NO_XFINITY_SERVICES;
      }

      if (isNowPage(window.location.pathname) && !hasEverHadNowServices(services)) {
        window.location.pathname = NO_NOW_SERVICES;
      }
    }

    return dispatch(dispatchGetContextHubSuccess(response));
  } catch (error) {
    dispatch(dispatchGetContextHubError(error));
    throw error;
  }
};

export const getConvoyIndicators = () => async (dispatch, getState) => {
  const {
    contextHub: { contextHub: { accountNumber } = {} } = {},
  } = getState();
  const isCottonSession = getCottonSession();
  if ((flagEnabled('txnDataTokenizationEnabled') || flagEnabled('txnDataPaymentEnabled'))) {
    try {
      const response = await dispatch(
        dispatchGetConvoyIndicators(accountNumber, isCottonSession),
      ).payload;
      return dispatch(dispatchGetConvoyIndicatorsSuccess(response));
    } catch (error) {
      // do nothing
      return null;
    }
  }
  return null;
};
